import styled from "styled-components";

export const StyledContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    margin-top: 16px;
    position: relative;
    transition: background-color 500ms ease-in-out;
`;

export const StyledInnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
`;
